import { IContactDetails } from './types'

export function serializeContactDetails(contactDetails: IContactDetails) {
  const nameArr = contactDetails.name.trim().split(' ')
  const firstName = nameArr.length > 2 ? nameArr.slice(0, -1).join(' ') : nameArr[0] || ''
  const lastName = nameArr.length > 1 ? nameArr[nameArr.length - 1] : ''

  return {
    email: contactDetails.email,
    profile: {
      first_name: firstName,
      last_name: lastName,
      phone_number: contactDetails.phone_number
    }
  }
}
